<a [href]="'#' + userCai" target="_blank" (click)="openWindow($event)">
  <span class="material-icons">{{icon}}</span> {{ user }}
</a>
